Directives.FeedMessageViewerDirective =  function FeedMessageViewerDirective(){

    // @ngInject
    function FeedMessageViewerDirectiveControllerFunc($sce, $scope, $injector, PvlService, FeedService, UIUtils) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'FeedMessageViewerDirectiveController';

        this.PvlService = PvlService;

        var body = this.messageModel.html_body;

        // Rip out client loginless links from HTML
        // Rip out style tags
        body = FeedService.cleanFeedItemHtml(body);

        this.htmlBody = $sce.trustAsHtml(body);

    }

    var FeedMessageViewerDirectiveController = Class(Controllers.BaseController, {
        constructor: FeedMessageViewerDirectiveControllerFunc,

        onViewPreferredVendors: function onViewPreferredVendors() {
            this.PvlService.showPreferredVendorList(this.messageModel.pvl_id, this.eventId);
        }
    });

    return {
        scope:{
            messageModel: '=messageModel',
            feedItem: '=feedItem',
            eventId: '@eventId',
            feedUsers: '=',
            feedOwnerCompanyId: '=?'
        },
        templateUrl : 'angular/app/modules/core/features/feed/viewer/feed_message_viewer_directive_template.html',
        controller : FeedMessageViewerDirectiveController,
        controllerAs : 'feedMessageViewerVm',
        bindToController : true
    };
};
